import React, { useState } from 'react';
import {
    Modal,
    Button,
    TextField,
    FormControl,
    FormLabel,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Box,
    Typography,
} from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";

interface AddFikraFeatureProps {
    open: boolean;
    handleClose: () => void;
}

const AddFikraFeature: React.FC<AddFikraFeatureProps> = ({ open, handleClose }) => {
    const [formData, setFormData] = useState({
        title: '',
        internalName: '',
        description: '',
        tiers: {
            free: false,
            premium: false,
            enterprise: false,
        },
        outputs: {
            web: false,
            pdf: false,
            excel: false,
        },
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleTierChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            tiers: { ...prev.tiers, [name]: checked },
        }));
    };

    const handleOutputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            outputs: { ...prev.outputs, [name]: checked },
        }));
    };

    const handleSubmit = () => {
        console.log('Saving Feature:', formData);
        handleClose();
    };

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={handleClose}>
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">
                    {/* Header */}
                    <div className="modal_title">
                        <h2>Add New Feature</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={handleClose}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">
                            <div className="control_group">
                                <label htmlFor="feature-title">Feature Title</label>
                                <TextField
                                    fullWidth
                                    name="title"
                                    value={formData.title}
                                    onChange={handleChange}
                                    placeholder="e.g. Market Analysis"
                                    hiddenLabel
                                    inputProps={{ id: "feature-title" }}
                                />
                            </div>

                            <div className="control_group">
                                <label htmlFor="internal-name">Internal Name (Slug)</label>
                                <TextField
                                    fullWidth
                                    name="internalName"
                                    value={formData.internalName}
                                    onChange={handleChange}
                                    placeholder="e.g. market_analysis"
                                    hiddenLabel
                                    inputProps={{ id: "internal-name" }}
                                />
                            </div>

                            <div className="control_group">
                                <label htmlFor="feature-description">Description</label>
                                <TextField
                                    fullWidth
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    placeholder="Brief description for internal use"
                                    multiline
                                    rows={2}
                                    hiddenLabel
                                    inputProps={{ id: "feature-description" }}
                                />
                            </div>

                           
                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex" style={{ marginTop: '24px' }}>
                            <Button
                                className="btn btn_grey"
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={handleSubmit}
                            >
                                Save Feature
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default AddFikraFeature;
